import type { Hit as AlgoliaHit } from 'instantsearch.js/es/types';
import React from 'react';

import { Snippet } from 'react-instantsearch-hooks-web';

type Order = {
  OrderID: string;
  SAPSalesOrder: number;
  SAPSalesOrderEquip: number;
};

export type QuotesHitProps = {
  hit: AlgoliaHit<{
    CustomerName: string;
    CustomerID: string;
    QuoteName: string;
    QuoteNo: string;
    QuoteID: string;
    Orders: Order[]
  }>;
};

export function QuotesHit({ hit }: QuotesHitProps) {
  return (
     <article className="hit">
      <div>
          <div>
          By <strong><Snippet hit={hit} attribute="CustomerName" /></strong>
        </div>
        <div>
          Customer ID: <strong>{hit.CustomerID}</strong>
        </div>
        <div>
          QuoteNo: <strong>{hit.QuoteNo}</strong>
        </div>
        <div>
          Quote Name: <strong>{hit.QuoteName}</strong>
        </div>
        <div>
          Quote ID: <strong>{hit.QuoteID}</strong>
        </div>
         {hit.Orders ? 
         <div>
          Orders: <strong>{ hit.Orders.map((order: Order) => { 
            return order.SAPSalesOrder ? order.SAPSalesOrder : order.SAPSalesOrderEquip
          }).join(', ') }</strong>
        </div> : '' }
      </div>
    </article>
  );
}